// extracted by mini-css-extract-plugin
export default {"v-hackster":"var(--hackster)","v-standardBorderRadius":"4px","label":"ratings__label__MsKej","checked":"ratings__checked__IeZ3i"};